<template>
<v-card outlined light flat :color="isProntuario == true? 'grey lighten-3'  : 'white' " elevation="2">
    <v-sheet min-height="70vh" rounded="lg">
      <v-toolbar :color="isProntuario == true? 'grey lighten-3'  : 'white' "  elevation="0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" v-if="!isProntuario" icon @click=" isExames == false? $emit('voltar') : isExames = false">
              <v-icon>
                arrow_back
              </v-icon>
            </v-btn>
          </template>
          <span>Voltar</span>
        </v-tooltip>
        
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" v-show="isProntuario && isExames" icon @click=" isExames == false? $emit('voltar') : isExames = false">
              <v-icon>
                arrow_back
              </v-icon>
            </v-btn>
          </template>
          <span>Voltar</span>
        </v-tooltip>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" color="compleA lighten-3" @click="downloadProntuario">
                  <v-icon color="white">open_in_new</v-icon>
              </v-btn>
          </template>
          <span>Mais históricos</span>
        </v-tooltip>
      </v-toolbar>
      <v-card outlined :color="isProntuario == true? 'grey lighten-3'  : 'white' " >
          <v-card v-if="load1" lign-self-start flat height="460px">
              <v-skeleton-loader max-width="999px" class="mt-2 ml-1" type="heading"> </v-skeleton-loader>
              <v-skeleton-loader class="mt-1" type="divider"> </v-skeleton-loader>
              <v-skeleton-loader v-for="(i) in 6" :key="i" max-width="350px" type="list-item"> </v-skeleton-loader>
          </v-card>

          <v-tabs v-model="tab" show-arrows v-if="!load1" disabled  background-color="grey" center-active dark class="pa-1" :class="!load1 ? 'animated fadeIn':'animated fadeOut'">
              <v-tabs-slider color="compleA lighten-2"></v-tabs-slider>
              <v-tab :disabled="isExames" v-for="(dataOs, k) in listaDeOS" :key="k" @click="retornarOsPorId(dataOs, k)">{{dataOs.dataSolicitacao}}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
              <v-card height="55vh" v-show="!isExames && !load2" flat :loading="load3" :disabled="load3" style="overflow-y: auto;">
                  <v-list  :class="(!isExames && !load2) ? 'animated fadeIn': 'animated fadeIOut'">
                      <v-list-item-group>
                          <v-list-item v-for="(consulta,j) in consultas" :key="j">
                              <v-list-item-content>
                                  <v-list-item-title v-if="consulta" @click="retornarProntuario(consulta.idConsulta)">Atendimento das {{consulta.dataChegada}}</v-list-item-title>
                                  <v-list-item-title v-else>Não há registros para essa data</v-list-item-title>
                              </v-list-item-content>
                          </v-list-item>

                      </v-list-item-group>
                  </v-list>
              </v-card>

              <!-- <div v-show="isExames">
            <v-list elevation="2" dense>
              <v-list-item-group no-action>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Atendimento das {{item.dataChegada}}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item-group>
            </v-list>
          </div> -->
              <v-card v-if="isExames" flat :color="isProntuario == true? 'grey lighten-3'  : 'white' " :class="isExames ? 'animated fadeIn': 'animated fadeOut'" class="pa-1">
                
                <v-expansion-panels flat >
                  <v-expansion-panel>
                    <v-expansion-panel-header :color="isProntuario == true? 'grey lighten-3'  : 'white' " >
                      <b>Prontuário</b>
                    </v-expansion-panel-header >
                    <v-expansion-panel-content :color="isProntuario == true? 'grey lighten-3'  : 'white' " >
                      <div v-html="osData.prontuario.descricao"> </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
              </v-expansion-panels>
                <!-- <v-list elevation="0" color="grey lighten-3" nav outlined>
                      <v-list-group no-action>
                          <template v-slot:activator>
                              <v-list-item-content>
                                <div class="mb-0">
                                  <h4>
                                    Prontuário
                                  </h4>
                                </div>
                                  <v-list-item-title style="font-size: 17px;"> Prontuário </v-list-item-title> 
                              </v-list-item-content>
                          </template>

                          <v-list-item no-actions>
                            <div v-html="osData.prontuario.descricao"></div>
                          </v-list-item>
                      </v-list-group>
                  </v-list> -->
                  <!-- Laudo
              <v-list elevation="1" outlined dense>
                <v-list-group no-action>
                  <template v-slot:activator>
                    <v-list-item-title>
                      <v-list-item-title> Laudo </v-list-item-title>
                    </v-list-item-title>
                  </template>
                  <v-list-item no-actions>
                    <div v-html="osData.laudo.descricao"></div>
                  </v-list-item>
                </v-list-group>
              </v-list> -->
                  <!--
                <v-expansion-panels focusable class="mt-3">

                  <v-expansion-panel>
                  <v-expansion-panel-header >
                    <span> Prontuário </span>
                    </v-expansion-panel-header>
                  <v-expansion-panel-content>

                      {{osData.receita[0].descricao}}
                  </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                <v-expansion-panel-header>Laudo</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-html="osData.laudo.descricao"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels> -->
                <div class="mx-6 mt-2 mb-0">
                      <h4>Receituário</h4>
                </div>
                <v-card height="auto" max-height="250px" :color="isProntuario == true? 'grey lighten-3' : 'white' "  style="overflow-y: auto;" outlined class="mt-2">
                  <v-card-title class="mx-2" v-if="!isArray(osData.prescricao)" style="font-size: 14px;">
                      Não houveram medicamentos receitados
                  </v-card-title>
                  <v-row v-else no-gutters class="mx-3">
                      <v-col v-for="(item, i) in osData.prescricao" :key="i" :style="{ background: i % 2 == 0 ? 'white' : '#e1e0e0' }" class="mt-0 mb-0" cols="12">
                          <v-list-item three-line>
                              <v-list-item-content>
                                  <v-list-item-title>
                                      {{ item.nome }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                      {{ item.apresentacao }}
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                      {{ item.obs }}
                                  </v-list-item-subtitle>
                              </v-list-item-content>
                          </v-list-item>
                      </v-col>
                  </v-row>
              </v-card>

                  <!-- SOLICITAÇãO DE EXAMES -->
                  <div class="mx-6 mt-2 mb-0">
                      <h4 >
                        Solicitação de Exames
                      </h4>
                    </div>
                  <v-card outlined :color="isProntuario == true? 'grey lighten-3'  : 'white' "  height="200px" style="overflow-y: auto;">
                    
                      <v-container grid-list-xl>
                          <v-card-title v-if="!isArray(osData.exames)" style="font-size: 14px;">
                              Não houveram exames solicitados
                          </v-card-title>
                          <v-row v-else class="mx-1">
                            <v-col cols="12" v-for="(exame,y) in osData.exames" :key="y">
                                <div :style="{ background: y % 2 == 0 ? 'white' : '#e1e0e0' }">
                                <v-list-item-title v-text="exame.nomeExame"/>
                                </div>

                              <v-divider />
                            </v-col>
                          </v-row>

                      </v-container>

                  </v-card>
                  <v-divider />
                  
              </v-card>
          </v-tabs-items>
      </v-card>
    </v-sheet>
    <!-- {{ listaDeOS }} -->
</v-card>
</template>

<script>
// import { Logger } from 'html2canvas/dist/types/core/logger'
import medicoService from '../../services/medico.service.js'

export default {
  props: {
    ficha: Object,
    isProntuario: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    load1: false,
    load2: false,
    load3: false,
    listaDeOS: [],
    osData: {},
    isExames: false,
    consultas: [],
    data: {},
    tab: '',
    teste: [
      {
        nome: 'nome',
        apresentacao: 'apresentacao',
        obs: 'obs'
      },
      {
        nome: 'nome',
        apresentacao: 'apresentacao',
        obs: 'obs'
      },
      {
        nome: 'nome',
        apresentacao: 'apresentacao',
        obs: 'obs'
      },
      {
        nome: 'nome',
        apresentacao: 'apresentacao',
        obs: 'obs'
      },
      {
        nome: 'nome',
        apresentacao: 'apresentacao',
        obs: 'obs'
      },
      {
        nome: 'nome',
        apresentacao: 'apresentacao',
        obs: 'obs'
      },
  
  ]

    /* data: {
          'laudo': {
            'idLaudo': 153,
            'descricao': '<p>teste 19</p>'
          },
          'receita': [{
            'idLaudo': 55,
            'descricao': 'descricaoX'
          }],
          'prescrição': [{
            'idPrescricao': 87,
            'idReceitaMedica': 55,
            'idMedicamento': 149,
            'nome': 'AAS PROTECT',
            'principioAtivo': 'ACIDO ACETILSALICILICO',
            'tarja': 'VENDA LIVRE',
            'classeTerapeutica': 'N02B0 - ANALGESICOS NAO NARCOTICOS E ANTIPIRETICOS',
            'laboratorioNome': 'SANOFI-AVENTIS FARMACEUTICA LTDA',
            'tipo': 'SIMILAR',
            'apresentacao': '100 MG COM REV CT BL AL/AL X 10',
            'restricaoHospitalar': 'NAO',
            'horarioPrescricao': [
              [{
                'idHorarioPrescricao': 214,
                'idTipoHorarioPrescricao': 48,
                'idPrescricao': 87,
                'descricao': 'Durante 3 semanas'
              },
              {
                'idHorarioPrescricao': 215,
                'idTipoHorarioPrescricao': 11,
                'idPrescricao': 87,
                'descricao': 'Em jejum'
              }
              ]
            ]
          },
          {
            'idPrescricao': 88,
            'idReceitaMedica': 55,
            'idMedicamento': 148,
            'nome': 'AAS',
            'principioAtivo': 'ACIDO ACETILSALICILICO',
            'tarja': 'TARJA VERMELHA',
            'classeTerapeutica': 'J02A0 - AGENTES SISTEMICOS PARA INFECCOES FUNGICAS',
            'laboratorioNome': 'SANOFI-AVENTIS FARMACEUTICA LTDA',
            'tipo': 'NOVO',
            'apresentacao': '100 MG COM CT FR PLAS OPC X 120',
            'restricaoHospitalar': 'NAO',
            'horarioPrescricao': [
              [{
                'idHorarioPrescricao': 216,
                'idTipoHorarioPrescricao': 4,
                'idPrescricao': 88,
                'descricao': '4 em 4 horas'
              }]
            ]
          }
          ],
          'solicitacao': {
            'idSolicitacao': 267,
            'dataCriacao': '2022-01-14T15:06:11.000Z',
            'dataUltimaModificacao': '2022-01-14T15:06:11.000Z'
          },
          'exames': [{
            'idExameSolicitacao': 267,
            'idExame': 15,
            'idSolicitacao': 191,
            'idExameEspecialidade': 67,
            'nomeExame': 'ACIDO CITRICO',
            'peso': 0,
            'medicoExigidoRecep': 0
          }]
        } */

  }),

  methods: {
    downloadProntuario () {
      // console.log('------');
      medicoService.medico.dowloadProntuario(this.ficha.idPaciente).then(r => {
        console.log(r.status)
        if (r.status == 200) {
          const file = new Blob(
            [r.data], {
              type: 'application/pdf'
            })
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file)
          // Open the URL on new Window
          window.open(fileURL)
        }
      })
    },
    retornarOsPorData () {
      this.load1 = true
      medicoService.medico.retornarInfoOsPorData(this.ficha.idPaciente)
        .then(r => {
          if (r.status === 200) {
            this.listaDeOS = r.data.listaOs

            for (var index in this.listaDeOS) {
              var data = new Date(this.listaDeOS[index].dataSolicitacao)
              console.log('--------')
              console.log(data)
              console.log(data.getMonth())
              console.log('--------')
              var dia = (data.getDate() > 9) ? data.getDate() : '0' + data.getDate()
              var mes = ((data.getMonth() + 1) > 9) ? (data.getMonth() + 1) : '0' + (data.getMonth() + 1)
              console.log(dia, mes, data.getFullYear())
              this.listaDeOS[index].dataSolicitacao = dia + '/' + mes + '/' + data.getFullYear()
            }

            this.listaDeOS.sort((a, b) => {
              var dateA = new Date(a.dataSolicitacao)
              var dateB = new Date(b.dataSolicitacao)
              return dateB - dateA
            })

            if (this.listaDeOS.length > 0) {
              this.retornarOsPorId(this.listaDeOS[0], 0)
            }
            this.load1 = false
          }
        })
        .catch(error => {
          // Tratar o erro, se necessário
          console.log(error)
          this.load1 = false
        })
    },

    retornarOsPorId (consulta, index) {
      console.log('------------', consulta, index)
      console.log(this.listaDeOS[index])
      this.load2 = true
      medicoService.medico.retornarConsultasOs(consulta.id).then(r => {
        //* * Excluí os atendimentos que tiver data = null */

        if (r.status == 200) {
          this.consultas = [0]
          var temp = r.data
          var cont = 0
          for (var i in temp) {
            if (temp[i].dataChegada != null) {
              var milissegundos = Date.parse(temp[i].dataChegada)
              var fullData = new Date(milissegundos)
              var minutos = 0
              var hora = 0
              if (fullData != null && fullData.getMinutes() > 9) {
                minutos = fullData.getMinutes()
              } else {
                minutos = '0' + fullData.getMinutes()
              }
              if (fullData != null && fullData.getHours() > 9) {
                hora = fullData.getHours()
              } else {
                hora = '0' + fullData.getHours()
              }
              temp[i].dataChegada = hora + ':' + minutos
              this.consultas[cont] = temp[i]
              cont++
            }
          }
          this.load2 = false
        }
      })
    },

    retornarProntuario (idConsulta) {
      console.log(idConsulta)
      this.load3 = true
      medicoService.medico.retornarProntuario(idConsulta).then(r => {
        console.log('STATUS: ', r.status)
        if (r.status == 200) {
          // this.load3 = true
          // console.log(this.load3)
          console.log('-----------', r.data)
          this.osData = r.data
          // console.log('array ',this.osData.prescricao)
          // this.load1 = false
          this.isExames = true
          console.log('Exames', this.osData.exames)
        }
      }).finally(() => {
        this.load3 = false
      })
    },
    isArray (array) {
      return Array.isArray(array)
    }
  },
  mounted () {
    this.retornarOsPorData()
    // this.retornarOsPorId(this.ficha.idOrdemServico)
  }

}
</script>

<style>
.v-card-text {
    font-size: 10px;
    margin-top: -40px;
    margin-bottom: -12px;
}

.v-card-title1 {
    font-size: 13px;
    margin-top: -15px;
    margin-bottom: -25px;
}

.v-card-title {
    font-size: 16px;
    margin-top: -10px;
}
</style>
